<div class="box custom-box h-full flex flex-col">
  <div class="box-header">
    <div class="box-title">Taxa de Conclusão por Grupo</div>
  </div>
  <div class="box-body !p-0 flex-1 flex flex-col">
    <!-- Loading State -->
    <div *ngIf="loading" class="flex items-center justify-center p-8">
      <app-loading-spinner message="Carregando taxa de conclusão..."></app-loading-spinner>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="flex items-center justify-center p-8">
      <div class="text-center text-danger">
        <div class="flex items-center gap-2 mb-4">
          <i class="ri-error-warning-line text-xl"></i>
          <p class="!mt-1">Erro ao carregar dados da taxa de conclusão</p>
        </div>
        <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadGroupsCompletionRate()">
          <i class="ri-refresh-line"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Success State - Horizontal Bar Chart -->
    <div *ngIf="!loading && !error && groupsCompletionRate.length > 0" id="groups-completion-rate-chart" class="flex-1">
      <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [colors]="chartOptions.colors!"
        [dataLabels]="chartOptions.dataLabels!" [stroke]="chartOptions.stroke!" [title]="chartOptions.title!"
        [grid]="chartOptions.grid!" [plotOptions]="chartOptions.plotOptions!" [xaxis]="chartOptions.xaxis!"
        [yaxis]="chartOptions.yaxis!" [tooltip]="chartOptions.tooltip!"></apx-chart>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && !error && groupsCompletionRate.length === 0" class="flex items-center justify-center p-8">
      <div class="text-center">
        <div class="text-muted">
          <i class="ri-bar-chart-line text-5xl mb-3"></i>
          <h6>Nenhum grupo encontrado</h6>
          <p class="mb-0">Não há grupos com dados de conclusão para exibir.</p>
        </div>
      </div>
    </div>
  </div>
</div>
